export enum UploadFileStatusEnum {
  inProcess = 0,
  completed = 1,
  error = 2,
}
